import LaunchIcon from "@mui/icons-material/Launch";
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import React from "react";

interface ISpecialInstructionAccountFieldProps {
  id: string;
  label: string;
  value?: string | number | null;
  md?: number;
  showIcon: boolean;
  onIconClick: () => void;
  iconTestId: string;
}

const labelContainerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  minHeight: 15,
  marginBottom: 4,
  color: "#767676",
  fontSize: 13,
};

const SpecialInstructionAccountField: React.FC<
  ISpecialInstructionAccountFieldProps
> = ({ id, label, value, md = 3, showIcon, onIconClick, iconTestId }) => {
  return (
    <Grid item md={md} xs={12}>
      <FormControl fullWidth size="small">
        <InputLabel shrink={true} htmlFor={id} style={{ fontSize: "13px" }}>
          <div style={labelContainerStyle}>
            <span>
              {label} <sup>&nbsp;</sup>
            </span>
            {showIcon ? (
              <Tooltip title="View Special Instructions">
                <IconButton
                  size="small"
                  data-testid={iconTestId}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onIconClick();
                  }}
                  style={{ padding: 0 }}
                >
                  <LaunchIcon className="blue-color" />
                </IconButton>
              </Tooltip>
            ) : null}
          </div>
        </InputLabel>
        <TextField
          autoComplete="off"
          id={id}
          data-testid={id}
          value={value ?? ""}
          name={id}
          disabled
          variant="outlined"
        />
      </FormControl>
    </Grid>
  );
};

export default SpecialInstructionAccountField;
